import React, { useMemo } from 'react';
import MirsTable from 'components/general/table/Table.js';
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { RaceColumns } from '../components/Columns';
import NotAvailable from 'components/common/NotAvailable';
import { isStartListStatus, isFinishedStatus, isLiveStatus } from 'helpers/status';
import CaptionTable from 'components/general/table/CaptionTable';
import Status from 'components/presentation/Status';
import SalRaceIncidents from "components/sports/sal/views/SalRaceIndicidents";
import { isFinals } from '../helper/SalHelpers';

function SalRace({ data }) {

  const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()

  const { breakPoint } = useViewport();
  const isMobile = breakPoint === "sm" || breakPoint === "xs" 

  const type = data?.results?.items?.length > 0 ? data?.results?.items[0]?.itemType : ''; // Team or Athlete
  const marksNum = data?.results?.extendedInfos?.find(ei => ei?.ei_code === 'MARKS_NUM')?.ei_value;
  let currentLeg = data?.results?.extendedInfos?.find(ei => ei?.ei_code === 'LEG_CURRENT')?.ei_value;
  const marks = data?.results?.extendedInfos?.filter(ei => ei?.ei_code === 'MARK' && ei?.ei_pos !== '0')?.sort((a, b) => a?.ei_pos - b?.ei_pos);
  currentLeg = currentLeg === '-' ? marksNum : currentLeg;
  const raceColumns = useMemo(() => RaceColumns(type, currentLeg, marks), []);

  const resultStatus = data?.results?.status?.code;
  const scheduleStatus = data?.results?.schedule?.status?.code;

  const isStartList = isStartListStatus(resultStatus);
  const isFinished = isFinishedStatus(resultStatus);
  const isLive = isLiveStatus(resultStatus)
 
  if (!data?.results?.items) return <NotAvailable />;

  const getHiddenColumns = () => {
    const finishedHidden = isFinished ? ['Move', 'EstOverall'] : []
    const startListHidden = isStartList ? ['Rank', 'Move'] : []
    const mobileHidden = isMobile ? [...marks?.map(m => 'Mark' + m?.ei_pos), 'Move'] : []
    const finalsHidden = isFinals(mirs_rsc) ? ['EstOverall'] : [];
    return [...finishedHidden, ...startListHidden, ...mobileHidden, ...finalsHidden];
  }

  let raceNumber = data?.results?.extendedInfos?.find(ei => ei?.ei_code === 'UNIT_NUMBER')?.ei_value;
  if (raceNumber.startsWith('S')){
    raceNumber = raceNumber.slice(2);
  } else if (raceNumber.startsWith('F')){
    raceNumber = raceNumber.slice(1);
  }
  
  const legsNum =  data?.results?.extendedInfos?.find(ei => ei?.ei_code === 'LEGS_NUM')?.ei_value
  const leg = isMobile && isLive && legsNum && currentLeg ? <>&nbsp;-&nbsp;<Label data="HeaderLeg" /> {`${currentLeg} / ${legsNum}`}</> : <></>

  const caption = (
    <CaptionTable
      leftCol={<span className="fw-bold"><Label data="HeaderRace" /> {raceNumber}{leg}</span>}
      rightCol={<Status typeToPrint="result" scheduleStatus={scheduleStatus} resultStatus={resultStatus} />}
     />
  );

  return (
    <>    
      <MirsTable
        id={`mirs-table-results-${mirs_rsc}`}
        caption={caption}
        data={data?.results?.items}
        columns={raceColumns}
        keyRow={"participant-code"}
        initialSortBy={[{ id: 'Rank', desc: false }]}
        hiddenColumns={getHiddenColumns()}
      />

      {!isFinishedStatus(resultStatus) && <SalRaceIncidents data={data} numRows={1} />}      
    </>
  );
}

export default SalRace;



